import {SystemColumnName} from 'data-frames/DataFrameConstants';
import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';
import {LEAF_TYPE_TO_ICON} from 'data-types/benchling-type-def/leafTypeToIcon';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export default function columnToTypeIcon(column: DataFrameColumnDef): BenchlingIconName {
  if (column.systemName === SystemColumnName.IS_EXCLUDED) {
    return 'cancelled';
  } else {
    return LEAF_TYPE_TO_ICON[column.type.leafType];
  }
}
